import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MUISelect from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import styled from '@mui/system/styled';
import theme from '../theme/theme';
import {Autocomplete, IconButton, TextField} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const Select = ({
  value,
  onChangeValue,
  items,
  label,
  disabled,
  multiple,
  width = 'auto',
  required,
  onClear,
  error = false,
  helperText = '',
  withSearch = false,
  inputValue,
  onInputChange,
  getOptionLabel,
  isElevator = false,
}) => {
  const handleChange = event => {
    const {
      target: {value},
    } = event;
    onChangeValue(typeof value === 'string' ? value.split(',') : value);
  };

  if (withSearch) {
    return (
      <FormControl sx={{width}} required={required} error={error}>
        <Autocomplete
          options={items}
          getOptionLabel={getOptionLabel}
          id="controlled-demo"
          value={value}
          inputValue={inputValue}
          onInputChange={onInputChange}
          onChange={(event, newValue) => {
            onChangeValue(newValue);
          }}
          renderInput={params => (
            <TextField {...params} label={label} variant="outlined" />
          )}
        />
      </FormControl>
    );
  }

  return (
    <FormControl sx={{width}} required={required} error={error}>
      <InputLabel id="complexes-label">{label}</InputLabel>
      <MUISelect
        labelId="demo-multiple-name-label"
        id="demo-multiple-name"
        multiple={multiple}
        value={value}
        disabled={disabled}
        onChange={handleChange}
        input={<OutlinedInput label={label} />}
        endAdornment={
          onClear && (
            <IconButton
              sx={{visibility: value ? 'visible' : 'hidden'}}
              onClick={onClear}>
              <ClearIcon />
            </IconButton>
          )
        }
        sx={{
          '& .MuiSelect-iconOutlined': {
            display: !!onClear && value ? 'none' : '',
          },
        }}
        // MenuProps={MenuProps}
      >
        {items.map(item => (
          <Items key={item.id} value={item.id}>
            {isElevator
              ? `${item.name} - ${item.buildingName}`
              : !!item?.firstName && !!item?.lastName
              ? `${item.firstName} ${item.lastName}`
              : item.name}
          </Items>
        ))}
      </MUISelect>
      {!!helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

const Items = styled(MenuItem)`
  &:hover,
  &.Mui-selected {
    background-color: ${theme.palette.grey[400]};
    color: ${theme.palette.primary.contrastText};

    &:hover {
      background-color: ${theme.palette.grey[600]};
    }
  }
`;

export default Select;
